import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Terminal, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Runs /ops commands as the signed-in user without a live Slack workspace.
export function SlackSimulator() {
  const [text, setText] = useState("");
  const [log, setLog] = useState([]);
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e?.preventDefault(); if (!text.trim()) return; setBusy(true);
    try { const { data } = await api.post("/admin/slack/simulate", { text }); setLog((l) => [{ q: text, a: data.text }, ...l]); setText(""); }
    catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };
  const render = (s) => (s || "").replace(/<([^|>]+)\|([^>]+)>/g, "$2").replace(/\*([^*]+)\*/g, "$1");
  return (
    <div className="panel p-5 text-sm" data-testid="slack-simulator">
      <h3 className="font-semibold mb-1 flex items-center gap-2"><Terminal className="w-4 h-4" /> Command simulator</h3>
      <p className="text-xs text-slate-500 mb-3">Try the Slack experience before the app is live. Runs as you, with your permissions. Examples: <code>add Call the client about renewal by Friday</code>, <code>plan …</code>, <code>status &lt;client&gt;</code>, <code>my</code>, <code>help</code>.</p>
      <form onSubmit={run} className="flex gap-2"><span className="text-slate-400 self-center font-mono text-xs">/ops</span><Input value={text} onChange={(e) => setText(e.target.value)} placeholder="add Follow up with the client tomorrow !high" className="font-mono text-xs" data-testid="slack-sim-input" /><Button type="submit" disabled={busy} className="rounded-full" data-testid="slack-sim-run">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Run"}</Button></form>
      <div className="mt-3 space-y-2 max-h-80 overflow-y-auto">{log.map((l, i) => <div key={i} className="rounded-xl bg-slate-900 text-slate-100 p-3 font-mono text-[11px] whitespace-pre-wrap" data-testid="slack-sim-result"><div className="text-slate-400 mb-1">/ops {l.q}</div>{render(l.a)}</div>)}</div>
    </div>);
}
